import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";
import "./index.css";

const GOIFieldBoolean = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const handleValueChange = (inputValue) => {
    onInputValueChange(inputData.id, inputValue);
  };

  const getClassNames = (value) => {
    return `cp boolean-div ${
      value ? "active-boolean-div" : "inactive-boolean-div"
    } ${
      disabled
        ? value
          ? "disabled-boolean"
          : "unselected-disabled-boolean"
        : ""
    }`;
  };
  return (
    <div className="boolean-div-container">
      <div
        className={getClassNames(value)}
        onClick={() => handleValueChange(true)}
      >
        True
      </div>
      <div
        className={getClassNames(value === false)}
        onClick={() => handleValueChange(false)}
      >
        False
      </div>
    </div>
  );
};

export default GOIFieldBoolean;
